export default "assets/logo-white-49de7a5e.png";